import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import BundleBuilderRedirect from '../components/navigation/BundleBuilderRedirect'
import * as actions from '../actions'
import { selectIsOrionSales } from '../selectors/session'

export const BundleBuilderLinkContainer = ({
  bundleBuilder = {},
  getBundleBuilderData,
  proceedToBundleBuilder,
  hideBundleBuilderModal,
  setCbmButtonScrollTriggered,
  customerType,
  launchCbmButtonRef,
  isOrionSales,
  ...props
}) =>
  !!bundleBuilder.showModal && (
    <BundleBuilderRedirect
      onCancel={hideBundleBuilderModal}
      onProceed={proceedToBundleBuilder}
      fields={bundleBuilder.reasons}
      showSrTicketError={bundleBuilder?.showSrTicketError}
      eligibleSystemCodes={bundleBuilder.eligibleSystemCodes}
      pageId={bundleBuilder.pageId}
      cbmLabelRef={launchCbmButtonRef}
      launchCbmButtonRef={launchCbmButtonRef}
      onCBMScrollChange={cbmButtonScrolled => 
        setCbmButtonScrollTriggered(cbmButtonScrolled)}
      customerType={customerType}
      isOrionSales={isOrionSales}
      {...props}
    />
  )
BundleBuilderLinkContainer.propTypes = {
  bundleBuilder: PropTypes.object,
  getBundleBuilderData: PropTypes.func.isRequired,
  proceedToBundleBuilder: PropTypes.func.isRequired,
  hideBundleBuilderModal: PropTypes.func,
  setCbmButtonScrollTriggered: PropTypes.func,
  customerType: PropTypes.string,
  launchCbmButtonRef: PropTypes.object,
  isOrionSales: PropTypes.bool
}

export const mapStateToProps = state => ({
  bundleBuilder: state.session.bundleBuilder,
  isLimitBBRoutingEnabled: state.session?.isLimitBBRoutingEnabled,
  customerType: state.session.appType,
  launchCbmButtonRef: state.order?.launchCbmButtonRef,
  isOrionSales: selectIsOrionSales(state)
})

export const mapDispatchToProps = {
  getBundleBuilderData: actions.getBundleBuilderData,
  proceedToBundleBuilder: actions.updateBundleBuilderData,
  hideBundleBuilderModal: actions.hideBundleBuilderModal,
  setCbmButtonScrollTriggered: actions.setCbmButtonScrollTriggered
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BundleBuilderLinkContainer)
